import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import { LayoutSpacerSmall } from '@pendwa/common-browser/components/LayoutSpacerSmall/index.js';
import React from 'react';
import { CreateAccount } from '../../../../../../components/UserComponents/CreateAccount/index.js';
import { LoginApple } from '../../../../../../components/UserComponents/LoginApple/index.js';
import { LoginFacebook } from '../../../../../../components/UserComponents/LoginFacebook/index.js';
import { LoginGoogle } from '../../../../../../components/UserComponents/LoginGoogle/index.js';
import { SendLoginCodeEmail } from '../../../../../../components/UserComponents/SendLoginCodeEmail/index.js';
import { SendLoginCodePhoneNumber } from '../../../../../../components/UserComponents/SendLoginCodePhoneNumber/index.js';

export const LoginOptions: React.FC<{
  handleSuccess: (params: { uuid: string; token: string }) => any;
}> = (props) => {
  const show_continue_with =
    (browserRootConfig.authentication.google.enable ||
      browserRootConfig.authentication.facebook.enable ||
      browserRootConfig.authentication.apple.enable) &&
    (browserRootConfig.authentication.login_code_email.enable ||
      browserRootConfig.authentication.login_code_phone.enable ||
      browserRootConfig.authentication.email_password.enable);

  return (
    <LayoutSpacer>
      <LayoutSpacerSmall>
        {browserRootConfig.authentication.google.enable && (
          <div className={'text-center'}>
            <LoginGoogle
              button_text={'CONTINUE WITH GOOGLE'}
              handleSuccess={(result) => {
                if (
                  result &&
                  result.data?.accountLoginGoogle.data?.uuid &&
                  result.data?.accountLoginGoogle.data?.token
                ) {
                  props.handleSuccess({
                    uuid: result.data.accountLoginGoogle.data.uuid,
                    token: result.data.accountLoginGoogle.data.token,
                  });
                }
              }}
            />
          </div>
        )}

        {browserRootConfig.authentication.facebook.enable && (
          <div className={'text-center'}>
            <LoginFacebook
              button_text={'CONTINUE WITH FACEBOOK'}
              handleSuccess={(result) => {
                if (
                  result &&
                  result.data?.accountLoginFacebook.data?.uuid &&
                  result.data?.accountLoginFacebook.data?.token
                ) {
                  props.handleSuccess({
                    uuid: result.data.accountLoginFacebook.data.uuid,
                    token: result.data.accountLoginFacebook.data.token,
                  });
                }
              }}
            />
          </div>
        )}

        {browserRootConfig.authentication.apple.enable && (
          <div className={'text-center'}>
            <LoginApple
              handleSuccess={(result) => {
                if (
                  result &&
                  result.data?.accountLoginApple.data?.uuid &&
                  result.data?.accountLoginApple.data?.token
                ) {
                  props.handleSuccess({
                    uuid: result.data.accountLoginApple.data.uuid,
                    token: result.data.accountLoginApple.data.token,
                  });
                }
              }}
            />
          </div>
        )}
      </LayoutSpacerSmall>

      {show_continue_with && (
        <div className="relative">
          <div aria-hidden="true" className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex justify-center text-sm/6 font-medium">
            <span className="bg-gray-50 px-6 text-gray-900">Or continue with</span>
          </div>
        </div>
      )}

      {browserRootConfig.authentication.login_code_email.enable && (
        <SendLoginCodeEmail
          handleSuccess={(result) => {
            if (
              result &&
              result.data?.accountLoginCode.data?.uuid &&
              result.data?.accountLoginCode.data?.token
            ) {
              props.handleSuccess({
                uuid: result.data.accountLoginCode.data.uuid,
                token: result.data.accountLoginCode.data.token,
              });
            }
          }}
        />
      )}

      {browserRootConfig.authentication.login_code_phone.enable && (
        <SendLoginCodePhoneNumber
          handleSuccess={(result) => {
            if (
              result &&
              result.data?.accountLoginCode.data?.uuid &&
              result.data?.accountLoginCode.data?.token
            ) {
              props.handleSuccess({
                uuid: result.data.accountLoginCode.data.uuid,
                token: result.data.accountLoginCode.data.token,
              });
            }
          }}
        />
      )}

      {browserRootConfig.authentication.email_password.enable && (
        <CreateAccount
          handleSuccess={(result) => {
            if (result && result.data?.accountCreate.data?.uuid && result.data?.accountCreate.data?.token) {
              props.handleSuccess({
                uuid: result.data.accountCreate.data.uuid,
                token: result.data.accountCreate.data.token,
              });
            }
          }}
        />
      )}
    </LayoutSpacer>
  );
};
